import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeStatusToDeclined,
  changeStatusToSignInProgress,
  createAgreement,
  fetchPdf,
  getAdobeDocument,
  setIntervalCounter,
} from "../../../redux/storageDocument/action";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";
import storePersist, { localConstant } from "../../../services/localStorage";
import { useState } from "react";
import CustomLoader from "../../../components/CustomLoader";

const AdobeDocument = () => {
  const { isLoading, isDocumentSigned, adobeDocumentUrl, intervalCounter } =
    useSelector((state) => state.storageDocumentReducer);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [fetchAgreementInterval, setFetchAgreementInterval] = useState(null);
  const intervalCounterRef = useRef(intervalCounter);
  const [isGetAdobeDocumentTriggered, setIsGetAdobeDocumentTriggered] =
    useState(false);

  const fetchAgreement = (agreementId) => {
    dispatch(
      getAdobeDocument(agreementId, (response) => {
        if (
          response?.response?.agreementStatus === "COMPLETED" ||
          response?.response?.participant?.[0]?.signStatus === "SIGNED"
        ) {
          storePersist.set(localConstant.AGREEMENT_STATUS, "COMPLTD");
          clearInterval(intervalId);
          clearInterval(fetchAgreementInterval);
          setFetchAgreementInterval(null);
          dispatch(setIntervalCounter(0));
          intervalCounterRef.current = null;
          navigate("/ownerDashboard");
        }
      }),
    );
    setIsGetAdobeDocumentTriggered(true);

    const intervalId = setInterval(() => {
      if (adobeDocumentUrl) {
        clearInterval(intervalId);
        clearInterval(fetchAgreementInterval);
        setFetchAgreementInterval(null);
        dispatch(setIntervalCounter(0));
        intervalCounterRef.current = null;
      }
      if (intervalCounterRef.current > 18) {
        enqueueSnackbar(
          "Error fetching eSign document from the server. Please try again !",
          {
            variant: "error",
            autoHideDuration: 3000,
            action: SnackbarConfig,
          },
        );
        clearInterval(intervalId);
        clearInterval(fetchAgreementInterval);
        setFetchAgreementInterval(null);
        dispatch(setIntervalCounter(0));
        intervalCounterRef.current = null;
        navigate("/ownerDashboard");
      }
      dispatch(
        getAdobeDocument(agreementId, (response) => {
          if (
            response?.response?.agreementStatus === "COMPLETED" ||
            response?.response?.participant?.[0]?.signStatus === "SIGNED"
          ) {
            storePersist.set(localConstant.AGREEMENT_STATUS, "COMPLTD");
            clearInterval(intervalId);
            clearInterval(fetchAgreementInterval);
            setFetchAgreementInterval(null);
            dispatch(setIntervalCounter(0));
            intervalCounterRef.current = null;
            navigate("/ownerDashboard");
          }
        }),
      );
      intervalCounterRef.current = intervalCounterRef.current + 1;
      dispatch(setIntervalCounter(intervalCounterRef.current));
    }, 3000);
    setFetchAgreementInterval(intervalId);
  };

  const eventHandler = (e) => {
    // if (e.origin === "https://secure.echosign.com") {
    console.log("Event from Acrobat Sign!", JSON.parse(e.data));
    if (JSON.parse(e.data).type === "REJECT") {
      storePersist.set(localConstant.AGREEMENT_STATUS, "DECLINED");
      dispatch(
        changeStatusToDeclined(
          storePersist.get(localConstant.ENTITY_CUSTOMER_ID),
          storePersist.get(localConstant.USER_ID),
          (response) => {
            if (response?.statusCode === 201) {
              storePersist.set(localConstant.AGREEMENT_STATUS, "AGR_CRTD");
            }
            navigate("/ownerDashboard");
          },
        ),
      );
      // navigate("/ownerDashboard");
    }
    // } else {
    //   console.log("Do not process this!");
    // }
  };

  useEffect(() => {
    if (!window.addEventListener) {
      window.attachEvent("onmessage", eventHandler);
    } else {
      window.addEventListener("message", eventHandler, false);
    }
    if (!storePersist.get(localConstant.AGREEMENT_ID)) {
      const customerId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
      const userId = storePersist.get(localConstant.USER_ID);
      dispatch(
        fetchPdf(customerId, userId, (response) => {
          if (response?.url) {
            const userData = storePersist.get(localConstant.USER_DATA);
            const params = {
              pdfUrl: response?.url,
              email: userData.entity_email,
              name: `${userData.entity_first_name} ${userData.entity_last_name}`,
            };
            dispatch(
              createAgreement(params, (response) => {
                if (response?.response?.agreementId) {
                  fetchAgreement(response?.response?.agreementId);
                }
              }),
            );
          }
        }),
      );
    } else {
      fetchAgreement(storePersist.get(localConstant.AGREEMENT_ID));
    }
  }, []);

  useEffect(() => {
    if (adobeDocumentUrl) {
      clearInterval(fetchAgreementInterval);
      setFetchAgreementInterval(null);
      dispatch(setIntervalCounter(0));
      intervalCounterRef.current = null;
    }
  }, [adobeDocumentUrl]);

  useEffect(() => {
    intervalCounterRef.current = intervalCounter;

    return () => {
      intervalCounterRef.current = null;
    };
  }, [intervalCounter]);

  const [iFrameLoads, setIFrameLoads] = useState(0);

  const redirectIFrame = () => {
    setIFrameLoads((prev) => prev + 1);
  };

  window.addEventListener(
    "message",
    (event) => {
      if ("https://secure.na2.echosign.com") {
        const responseData = event.data;
        const convertedRespose = JSON.parse(responseData);
        if (convertedRespose?.type === "ESIGN") {
          navigate("/eSignVerification");
        }
      }
    },
    false,
  );

  const renderElements = (
    <>
      {adobeDocumentUrl && !isDocumentSigned && (
        <iframe
          sandbox="allow-top-navigation allow-scripts allow-same-origin allow-popups allow-forms"
          onLoad={redirectIFrame}
          src={adobeDocumentUrl}
          title="Adobe Document"
          target="_parent"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            height: "100%",
            border: "none",
            margin: 0,
            padding: 0,
            overflow: "hidden",
            flex: 1,
          }}
        ></iframe>
      )}
      {storePersist.get(localConstant.AGREEMENT_STATUS) !== "IN_PRGRS" &&
        isLoading && (
          <div
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            <CustomLoader text={"Please wait, Loading the document ...."} />
          </div>
        )}
    </>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {renderElements}
      {isLoading && <CustomLoader />}
    </div>
  );
};

export default AdobeDocument;
